module.exports = __webpack_public_path__ + "static/media/QRCode.d3b38dfa.jpg";